import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DomainService } from '../../services/domain.service';

declare var swal: any;

@Component({
  selector: 'app-domain-login',
  templateUrl: './domain-login.component.html',
  styleUrls: ['./domain-login.component.css']
})
export class DomainLoginComponent implements OnInit {
  loading = false;
  domain_login_link = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private domainService: DomainService
  ) { }

  ngOnInit() {
    this.domain_login_link = `https://auth.domain.com.au/v1/connect/authorize?client_id=${environment.domainClientId}&redirect_uri=${environment.htmlEndpoint}/domain/login&response_type=code&scope=openid%20profile%20api_listings_read%20api_agencies_read%20public-basic-profile`;

    this.route.queryParams.subscribe(
      (params: Params) => {
        if ( params['code'] !== undefined ) {
          this.domainService.httpLogin({
            grant_type: 'authorization_code',
            redirect_uri: `${environment.htmlEndpoint}/domain/login`,
            code: params['code']
          });

          swal({
            title: 'Preparing this device...',
            onOpen: function () {
              swal.showLoading ();
            }
          });
        }
      }
    );

    this.domainService.domainLogin.subscribe(
      (auth: any) => {
        if ( typeof auth !== 'undefined' && auth.status === 'success' ) {
          this.loading = false;
          this.authService.setAuthStorage(auth);
          const $this = this;

          window.location.href = '/campaigns';
        }
        if ( typeof auth !== 'undefined' && auth.status === 'billingissue' ) {
          this.loading = false;
          swal(
            'Whoops, it looks like your subscription has not been paid.',
            'Please contact 1300 650 520 to arrange payment and get back to designing.',
            'error'
          );
        }
        if ( typeof auth !== 'undefined' && auth.status === 'blocked' ) {
          this.loading = false;

          swal({
            title: '',
            type: 'error',
            html:
              // tslint:disable-next-line:max-line-length
              '<p><strong>Doesn’t look like you have an account, please click <a target="_blank" href="https://websites.formstack.com/forms/designlyregistration">here</a> to enquire</strong></p>'
          });
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/domain-login/domain-login.component.ts